import { is, isObject, isRecordOf, isIntersectionOf, isUnionOf, isLiteral, } from "@jaybeeuu/is";
/**
 * Base output metadata for all manifest entries (current format with hash).
 */
export const isBaseManifestEntry = isObject({
    title: is("string"),
    fileName: is("string"),
    href: is("string"),
    lastUpdateDate: isUnionOf(is("string"), is("null")),
    publishDate: is("string"),
    hash: is("string"),
    slug: is("string"),
});
export const isManifestEntry = (entryPredicate) => {
    return isIntersectionOf(entryPredicate, isBaseManifestEntry);
};
export const isManifest = (customEntryProsPredicate) => {
    return isObject({
        version: isLiteral(2),
        metadata: isObject({
            generatedAt: is("string"),
            entryCount: is("number"),
            overallHash: is("string"),
        }),
        entries: isRecordOf(isManifestEntry(customEntryProsPredicate)),
    });
};
//# sourceMappingURL=manifest.js.map